<template>
  <div class="no-posts">
    <img
      src="@/static/posts/noPosts.svg"
      :alt="$t('message.posts.list.noPostsAlt')"
    />
    <p class="no-posts__description">
      {{ $t("message.posts.list.noPostsDescription") }}
    </p>
    <ui-button
      v-if="canAddAndDeleteLocalPosts"
      :to="{ name: 'posts-add' }"
      color="primary"
      icon="icon-plus"
    >
      {{ $t("message.common.addNew") }}
    </ui-button>
  </div>
</template>

<script>
import { permissionsInfo } from "@/helpers/mixins/permissions-info";

export default {
  name: "PostsListEmpty",
  mixins: [permissionsInfo]
};
</script>

<style lang="scss" scoped>
.no-posts {
  @include noData(550px);

  &__description {
    @include font-size(13px);
    text-align: center;
    max-width: 75%;
    margin: $spacing * 5 0 $spacing * 3;
    white-space: pre-wrap;
  }
}
</style>
